import { ApolloClient, InMemoryCache } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';
import { BASE_PATH } from 'constants/constants';

const client = new ApolloClient({
  uri: `${BASE_PATH}/api/query`,
  cache: new InMemoryCache({
    typePolicies: {
      Preview: {
        keyFields: ['id'],
      },
      Category: {
        keyFields: ['id'],
        fields: {
          contents: offsetLimitPagination(),
        },
      },
      Tag: {
        keyFields: ['id'],
        fields: {
          contents: offsetLimitPagination(),
        },
      },
      Service: {
        keyFields: ['id'],
        fields: {
          contents: offsetLimitPagination(),
        },
      },
      Content: {
        keyFields: ['id'],
      },
    },
  }),
});

export default client;
